<template>
  <!--招聘活动  -->
  <div class="container">
    <div class="content">
      <div>
        <module-title title="招聘活动"></module-title>
        <div v-for="(item, index) in activityList" :key="index">
          <activity
            :id="item.zphdid"
            :title="item.zphdmc"
            :showIcon="item.showIcon"
            :startDate="item.zphdbmkssj"
            :endDate="item.zphdbmjssj"
            :showEnd="item.hdzt"
            :date="item.zphdfbsj"
            :type="item.zphdlx"
            :zplb="item.zplb"
          ></activity>
        </div>
        <pagination
          :total="pagination.total"
          @currentPageChange="currentPageChange"
          @pageSizeChange="pageSizeChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moduleTitle from "@/components/moduleTitle";
import activity from "@/components/activity";
import pagination from "@/components/pagination";
import request from "@/api/home.js";
export default {
  components: {
    moduleTitle,
    activity,
    pagination
  },
  data() {
    return {
      pagination: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      activityList: []
    };
  },
  mounted() {
    this.getZphd();
  },
  methods: {
    /**
     * 每页大小改变时，响应方法
     */
    pageSizeChange(e) {
      this.pagination.pageSize = e;
      this.pagination.page = 1;
      console.log(e);
      this.getZphd();
    },
    /**
     * 当前页变更时，响应方法
     */
    currentPageChange(e) {
      this.pagination.page = e;
      console.log(e);
      this.getZphd();
    },

    /**
     * 获取招聘活动
     */
    /**
     * 获取招聘活动
     */
    getZphd() {
      let param = {
        page: this.pagination.page, //页码
        pageSize: this.pagination.pageSize //每页显示的条数
      };
      let that = this;
      request
        .getZphd(param)
        .then(function(data) {
          that.pagination.total = data.total;
          that.activityList = data.vds;
          console.log("response");
          console.log(data);
        })
        .catch(function(error) {
          console.log("error");
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  background: #f7f9fa;
  .content {
    width: 70%;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
  }
}
</style>
